const target = '_blank'
const features = 'noopener,noreferrer'
const isMobile =
  typeof navigator === 'object' &&
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

const defaultUrl = document.location.origin

export function facebook({ text, url = defaultUrl }) {
  const base = 'https://facebook.com/sharer.php'
  window.open(
    `${base}?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text.replace(/\s+/, ' '))}`,
    target,
    features
  )
}

export function twitter({ text, url = defaultUrl }) {
  const base = 'https://twitter.com/intent/tweet'
  window.open(
    `${base}?text=${encodeURIComponent(text.replace(/\s+/, ' '))}&url=${encodeURIComponent(url)}`,
    target,
    features
  )
}

export function whatsapp({ text, url = defaultUrl }) {
  const platform = isMobile ? 'api' : 'web'
  const base = `https://${platform}.whatsapp.com/send`

  window.open(`${base}?text=${encodeURIComponent(text.replace(/\s+/, ' ') + ' ' + url)}`, target, features)
}



// WEBPACK FOOTER //
// ./src/util/share.js